export default function scrollToSelector(selector, duration, delayTime) {
  duration = duration || 500;
  delayTime = delayTime || 100;

  const wpAdminBarHeight =
    $('#wpadminbar').length > 0 ? $('#wpadminbar').outerHeight() : 0;
  const headerHeight = $('.banner').length > 0 ? $('.banner').outerHeight() : 0;
  const topOffset = headerHeight + wpAdminBarHeight + 10;
  const selectorTopOffset = $(selector).offset() ? $(selector).offset().top : 0;

  // Set time out to allow for other changes that affect the dom to properly propagate
  setTimeout(() => {
    $('html, body').animate(
      {
        scrollTop: selectorTopOffset - topOffset,
      },
      duration
    );
  }, delayTime);
}



// WEBPACK FOOTER //
// ./scripts/util/scrollToSelector.js